import React from 'react';
import { Github, Linkedin, Mail, Download } from 'lucide-react';
import { personalInfo } from '../data/mock';
import { Button } from './ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-[#2a2a2a] py-12 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold monospace mb-3">{'<SJ />'}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Senior Mobile Engineer building production-grade apps that scale.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-4 text-gray-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#projects" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Projects
                </a>
              </li>
              <li>
                <a href="#skills" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Skills
                </a>
              </li>
              <li>
                <a href="#experience" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Experience
                </a>
              </li>
              <li>
                <a href="#blogs" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Blogs
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-4 text-gray-400">Get In Touch</h4>
            <div className="space-y-3">
              <a
                href={`mailto:${personalInfo.email}`}
                className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
              >
                <Mail size={16} />
                {personalInfo.email}
              </a>
              <div className="flex gap-4">
                <a
                  href={personalInfo.social.github}
                  className="text-gray-400 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Github size={20} />
                </a>
                <a
                  href={personalInfo.social.linkedin}
                  className="text-gray-400 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Download Resume */}
        <div className="flex justify-center mb-8">
          <Button
            onClick={() => window.open(personalInfo.resumeUrl, '_blank')}
            className="bg-white text-black hover:bg-gray-200 font-semibold px-8 py-6 text-base"
          >
            <Download className="mr-2" size={18} />
            Download Resume
          </Button>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#2a2a2a] pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} {personalInfo.name}. Engineered with precision.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;